import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Meta } from '@angular/platform-browser';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import Swal from 'sweetalert2';
import { TokenService } from './token.service';
import { ApplicationhttpService } from './applicationhttp.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { HostListener } from '@angular/core';



@Component({
   selector: 'silk-app',
   templateUrl: './app.component.html',
   encapsulation: ViewEncapsulation.None
})
export class SilkAppComponent {

   phoneUs: '(000) 000-0000';
   idleState = 'Not started.';
   timedOut = false;
   lastPing?: Date = null;
   title = 'angular-idle-timeout';
   idealTime:Number=240;

  public modalRef: BsModalRef;
  @ViewChild(ModalDirective) childModal: ModalDirective;

   constructor(private keepalive: Keepalive,private ser: ApplicationhttpService,private tokenService: TokenService, private idle: Idle, private router: Router, public translate: TranslateService, private metaTagService: Meta,private modalService: BsModalService) {
      translate.addLangs(['en', 'fr']);
      translate.setDefaultLang('en');

      const browserLang: string = translate.getBrowserLang();
      translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');


      idle.setIdle(60*20);
      // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
      idle.setTimeout(5);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      idle.onIdleEnd.subscribe(() => {
         this.idleState = 'No longer idle.'
         console.log(this.idleState);
         this.reset();
      });

      idle.onTimeout.subscribe(() => {
         this.idleState = 'Your session has expired. You will be redirected to the Login page.';
         this.router.navigate(['/authentication']);
         localStorage.removeItem('Token');
         localStorage.removeItem('LoggedUserID');
         localStorage.removeItem('LoggedUserRole');
         this.tokenService.setUserLoggedIn(false);
         this.tokenService.removeRefreshToken();
         this.tokenService.removeToken();
         for (var obj in localStorage) {
              localStorage.removeItem(obj);
          }
         this.timedOut = true;
         console.log(this.idleState);
      });

      idle.onIdleStart.subscribe(() => {
         this.idleState = 'You\'ve gone idle!'
         console.log(this.idleState);
      });

      idle.onTimeoutWarning.subscribe((countdown) => {
         this.childModal.show();
         this.idle.stop();
         //this.idleState = 'Your Session will be expired  in ' + this.idealTime + ' seconds!'
         this.ProgressCountdown(10, 'pageBeginCountdown', 'pageBeginCountdownText').then(
            value => {
               this.timedOut=true;
               this.idleState = 'Your session has expired. You will be redirected to the Login page.';
               this.router.navigate(['/authentication']);
               localStorage.removeItem('Token');
               localStorage.removeItem('LoggedUserID');
               localStorage.removeItem('LoggedUserRole');
               this.tokenService.setUserLoggedIn(false);
               this.tokenService.removeRefreshToken();
               this.tokenService.removeToken();
               this.timedOut = true;
               for (var obj in localStorage) {
                  localStorage.removeItem(obj);
              }
               console.log(this.idleState);
            }
          )
         console.log(this.idleState);
      });

      // // sets the ping interval to 15 seconds
      keepalive.interval(15);

      keepalive.onPing.subscribe(() => this.lastPing = new Date());

      this.tokenService.getUserLoggedIn().subscribe(userLoggedIn => {
         var user =localStorage.getItem('LoggedUserID');
         if (userLoggedIn && user!=undefined && user !=null && user !="") {
            idle.watch()
            this.timedOut = false;
         } else {
            idle.stop();
         }
      })


   }

   ngOnInit() {

      this.metaTagService.addTags([
         { name: 'keywords', content: 'Integrated Resource Tracking Software as a service, Integrated Resource Tracking System, Cloud Based Integrated Resource Tracking, Integrated Resource Tracking SaaS, Integrated Resource Tracking Cloud Based, Integrated Resource Tracking Application, Cloud based SaaS, Integrated Resource Tracking, Application service provider, Cloud based management, Software as a service HR, SaaS management, SaaS Application, SaaS Platform, SaaS product, SaaS cloud, cloud based software, IRTS SaaS Providers, SaaS providers, Cloud based SaaS, SaaS web application, cloud migration software,  HR SaaS providers, cloud monitoring software, cloud database Application, cloud based management system, Cloud based Application hr management, Staff Management Application, Employee time tracker, employee time management system, online timesheet system, time management system for employees, staff time tracker, online timesheet tracker, employee time and attendance software, employee timesheet system, online employee attendance management, time clock employee tracking, employee timesheet tracker, employee data management software, software for time and attendance, online employee attendance tracker, human resources software, hr management system, hr management software, human resource management system software, online hr system, hr and payroll system, HR cloud software, HR application software, HR dashboard software,  HR management SaaS, HR software tools, online hr software, hr payroll system, cloud based hr software, hr tracking software, hr and payroll system, hr management system software, SaaS HR system, human resource software systems, cloud based hr and payroll, payroll & hrms, employee HR software, HR management SaaS, integrated HR and payroll software, cloud based hr management system, hr and payroll management software, hr reporting software, human resource management Application, online hr management system, online human resource management system, hrms and payroll software,  human resource and payroll software, SaaS HR payroll, HR software tracking, cloud based hr management, hr software tracking, hr tracking system, accounting system services, 401K management services,  payroll web services, human resource background check services, hr background check services SaaS, web based HR management software, web based HR management Application, ess payroll, employee self-service system, HR ess, HR employee self-service, performance payroll employee self-service, hrms employee self-service, web based HR management software, timesheet management system, timesheet management application, employee relationship management, human resource management information system, cloud hr system, hr database systems, hr database systems, hr resource management, hr and payroll management system,  human resources management applications, Track company resources, Ideal Resource Tracking, Company Navigation Tool, Global Resource Tracking, Global HRM, Talent Management Software, Global HR, Workforce Management,  Asset Tracking, Financial Resource Tracking, Paperless Office HRM, Green Office HRM, Records Retention HRM, Web Services Integrated HCM,  API Based HRM, Automated Resource Tracking, Automated HRM' },
         { name: 'robots', content: 'index, follow' },
         { name: 'author', content: 'Digamber Singh' },
         { name: 'viewport', content: 'width=device-width, initial-scale=1' },
         { name: 'date', content: '2021-01-01', scheme: 'YYYY-MM-DD' },
         { charset: 'UTF-8' }
      ]);
   }


   reset() {
      this.idle.watch();
      this.timedOut = false;
   }

   logout(){
      this.childModal.hide();
     
      this.router.navigate(['/authentication']);
      localStorage.removeItem('Token');
      localStorage.removeItem('LoggedUserID');
      localStorage.removeItem('LoggedUserRole');
      this.tokenService.setUserLoggedIn(false);
      this.tokenService.removeRefreshToken();
      this.tokenService.removeToken();
      for (var obj in localStorage) {
         localStorage.removeItem(obj);
     }
   }

   // hideChildModal(){
   //    this.childModal.hide();
   //    this.router.navigate(['/authentication']);
   //    localStorage.removeItem('Token');
   //    localStorage.removeItem('LoggedUserID');
   //    localStorage.removeItem('LoggedUserRole');
   //    this.tokenService.setUserLoggedIn(false);
   //    this.tokenService.removeRefreshToken();
   //    this.tokenService.removeToken();
   // }

   okclick(){
      this.childModal.hide();
      this.router.navigate(['/authentication']);
      localStorage.removeItem('Token');
      localStorage.removeItem('LoggedUserID');
      localStorage.removeItem('LoggedUserRole');
      this.tokenService.setUserLoggedIn(false);
      this.tokenService.removeRefreshToken();
      this.tokenService.removeToken();
   }

   stay(){
      this.ser.refreshaccess_token();
      this.timedOut = false;
   }

  

   ProgressCountdown(timeleft, bar, text) {
      return new Promise((resolve, reject) => {
        var countdownTimer = setInterval(() => {
          timeleft--;
          (<HTMLInputElement>document.getElementById(bar)).value=timeleft;
          (<HTMLInputElement>document.getElementById(text)).textContent = timeleft;
          if (timeleft <= 0) {
            clearInterval(countdownTimer);
            resolve(true);
          }
        }, 1000);
      });
    }

    @HostListener('document:visibilitychange', ['$event'])
  clickout(event) {
   console.log("tabchanged");
  }

 
// //document.addEventListener("visibilitychange", function() {
// //       if (document.hidden) {
// //         //do whatever you want
// //         console.log("Hidden");
// //       }
// //       else {
// //         //do whatever you want
// //         console.log("SHOWN");
// //       }
// // });
}
